(function () {
  customerLoginModal.$inject = ["API_URL"];
  angular.module('calendarApp').directive('customerLoginModal', customerLoginModal);

  function customerLoginModal(API_URL) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/customer-login-modal.html',
      scope: {
        parentScope: '='
      },
      link: function link(scope, elem, attrs) {
        scope.loginModal = scope;

        scope.parentScope.showLoginModal = function () {
          $('#customer-login-modal').modal('show');
        };

        scope.hideModal = function () {
          $('#customer-login-modal').modal('hide');
        };
      }
    };
  }
})();